import { useEffect } from 'react';
import { WidgetConfigResponse } from 'rwl-shared/dist/models';
import { useMap } from 'rwl-ui';

export const useInitializeMap = (config: WidgetConfigResponse | undefined) => {
    const { setApiKey, isInitialized } = useMap();

    useEffect(() => {
        if (config?.googleMapsKey && !isInitialized) {
            setApiKey(config.googleMapsKey);
        }
    }, [config, isInitialized]);
};
